export const endorsementTypes = {
    EDUCATOR: "Educator",
    PARKING_GUARD: "Parking Guard",
    OEM_APPROVED: "OEM Approved",
};

export const endorsementCodes = {
    EDUCATOR: "001",
    PARKING_GUARD: "003",
};

export const endorsementQuestionNumbers = {
    EDUCATOR: 1,
    PARKING_GUARD: 2,
};

export function getDefaultEndorsementQuestionAnswers() {
    return [];
}
